/* eslint-disable import/no-cycle */
import React from 'react';
import PropTypes from 'prop-types';

const WsRatingBlock = ({ config }) => <></>;

WsRatingBlock.propTypes = { config: PropTypes.object };

export default WsRatingBlock;
